import { VariablesInputPage } from "./VariablesInputPage";
import { useAuth } from "../contexts/useAuth";
import { useOrganisation } from "../hooks/useOrganisation";

export const ConnectedVariablesInputPage = () => {
  const { user } = useAuth();
  const organisationId = user?.organisation_id ?? "";
  const { data: organisationData, isLoading } = useOrganisation(organisationId);

  if (isLoading || !organisationData) {
    return <div className="skeleton h-4 w-full"></div>;
  }

  const labTypeSubscriptions = organisationData.subscriptions || [];

  return <VariablesInputPage labTypeSubscriptions={labTypeSubscriptions} />;
};
